import { FunctionComponent } from "react";
import { TYPES_ARCHIVES } from "../../constants/types-export";
import { ExportButtonProps } from "./export.types";
import { ArrowDownToLine, Loader2 } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

export const ExportButton: FunctionComponent<ExportButtonProps> = ({
  className,
  handleExport,
  customFunction,
  placeholder,
  isLoading = false,
}) => {
  const formatExtension = (value: string) => {
    return value.replace(".", "");
  };

  const handleExportFile = async (type: string) => {
    if (isLoading) return;

    customFunction && customFunction();
    handleExport(formatExtension(type));
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          "p-2 border border-black rounded-md text-sm hover:bg-neutral-100 min-h-[40px] flex gap-1 items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed",
          className,
        )}
        disabled={isLoading}
      >
        {isLoading ? (
          <Loader2 className="w-4 animate-spin" />
        ) : (
          <ArrowDownToLine className="w-4" />
        )}
        {placeholder}
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {Object.entries(TYPES_ARCHIVES).map(([key, type]) => (
          <DropdownMenuItem
            key={key}
            onClick={() => {
              handleExportFile(type);
            }}
            disabled={isLoading}
          >
            {key}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
